module.exports = __webpack_public_path__ + "media/assets/images/flags/mu-57208670cae076008c300244aaa5bf24.svg";